

















































































import {Component, Vue} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {getToday, addMonth, changeDateFormat} from '@/utils/dateUtils';
import {i18nInObjectList} from '@/utils/i18n';
import {Mall} from 'supporter';

const mallModule = namespace('mall');
@Component({
  components: {CompSelectBox, PeriodDateCalendar, RadioElement, ItemTable}
})
export default class MemberExpel extends Vue {
  // 쇼핑몰 선택
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private defaultRejoinBtnFlg = true;
  private showRejoinBtn = true;
  private get mallList() {
    let res: any = [];
    if (this.malls) {
      this.malls.forEach(mall => {
        res.push({
          value: mall.mallNo,
          name: mall.mallName
        });
      });
    }
    return res;
  }
  private async selectMall() {
    let {data} = await this.$api.getWithdrawalMembersRejoinability({params: {mallNo: this.mallNo}});
    this.showRejoinBtn = data.rejoinability;
  }

  // 검색어
  private searchType = 'ALL';
  private searchTypes = [
    {value: 'ALL', name: 'COMMON_ALL'},
    {value: 'USER_ID', name: 'MEMBER_SEARCH_KEY_WORD_USER_ID'},
    {value: 'NAME', name: 'MEMBER_SEARCH_KEY_WORD_NAME'},
    {value: 'NICKNAME', name: 'MEMBER_SEARCH_KEY_WORD_NICKNAME'},
    {value: 'EMAIL', name: 'MEMBER_SEARCH_KEY_WORD_EMAIL'},
    {value: 'MOBILE', name: 'MEMBER_SEARCH_KEY_WORD_MOBILE'}
  ];
  private keyword = '';

  // 탈퇴일자
  private searchDateUsed = 'false';
  private usedTypes = [
    {value: 'false', name: 'MEMBER_SEARCH_DATE_ALL'},
    {value: 'true', name: 'MEMBER_SEARCH_DATE_PEROID'}
  ];
  private startYmd: string = addMonth(new Date(), -3);
  private endYmd: string = getToday();

  // 재가입 여부
  private rejoinability = '';
  private rejoinabilitys = {
    name: 'rejoinabilitys',
    data: [
      {
        id: 'rejoinabilitys_all',
        value: '',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'rejoinabilitys_true',
        value: 'true',
        dispaly: 'MEMBER_EXPEL_REJOINABILITY_YES'
      },
      {
        id: 'rejoinabilitys_false',
        value: 'false',
        dispaly: 'MEMBER_EXPEL_REJOINABILITY_NO'
      }
    ]
  };

  // 조회
  private size = 30;
  private expelData = [] as any;
  private totalCount: number = 0;
  private async search(page: number = 1, size?: number) {
    if (size) {
      this.size = size;
    }
    if (this.searchType !== 'ALL' && this.keyword === '') {
      alert(this.$t('COMMON_PLEASE_INPUT'));
      (this.$refs.keyword as any).focus();
      return;
    }
    let request: any = {
      params: {
        mallNo: this.mallNo,
        searchType: this.searchType,
        keyword: this.keyword,
        searchDateUsed: this.searchDateUsed,
        rejoinability: this.rejoinability,
        page,
        pageSize: this.size
      }
    };
    if (this.searchDateUsed === 'true') {
      request.params.startDateTime = this.startYmd + ' 00:00:00';
      request.params.endDateTime = this.endYmd + ' 23:59:59';
    }
    const {data} = await this.$api.getWithdrawalMembers(request);
    this.expelData = data.contents;
    this.totalCount = data.totalCount;
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = this.size;
    this.gridProps.options.pageOptions.totalCount = data.totalCount;
  }
  private disableRowChecks() {
    let grid = this.$refs.itemTable as any;
    let tempData = grid.gridFunction('getData');
    tempData.forEach(item => {
      if (item.memberType !== 'MALL') {
        grid.gridFunction('disableRow', [item.rowKey]);
      }
    });
  }

  // 초기화
  private reset() {
    this.mallNo = this.malls[0].mallNo;
    this.searchType = 'ALL';
    this.keyword = '';
    this.searchDateUsed = 'false';
    (this.$refs.periodDate as any).clickPeriod('3m');
    this.showRejoinBtn = this.defaultRejoinBtnFlg;
    this.rejoinability = '';
  }

  // 조회결과
  private contentBottomOption = {
    gridName: 'MEMBER_EXPEL_GRID',
    haveConfigBtn: true,
    haveExcelDownBtn: false,
    onLoadSearch: false,
    afterFunction: this.disableRowChecks
  };
  private gridProps = {
    columns: [
      {
        header: 'MEMBER_LIST_ITEM_MEMBER_NO',
        name: 'memberNo',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'MEMBER_LIST_ITEM_MEMBER_NAME',
        name: 'memberName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'MEMBER_LIST_ITEM_MEMBER_ID',
        name: 'memberId',
        align: 'center',
        minWidth: 120,
        formatter: (cell: any) => {
          if (cell.row.openIdProvider !== null) {
            return cell.row.openIdProvider;
          } else {
            return cell.value;
          }
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_ITEM_MEMBER_NICKNAME',
        name: 'nickname',
        align: 'center',
        minWidth: 100,
        formatter: (cell: any) => {
          return cell.row.nickName;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_LIST_ITEM_MEMBER_GRADE',
        name: 'memberGradeName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'MEMBER_EXPEL_LIST_ITEM_MEMBER_GROUP',
        name: 'memberGroupNames',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'MEMBER_EXPEL_LIST_ITEM_WITHDRAW_REASON',
        name: 'withdrawalReason',
        minWidth: 180
      },
      {
        header: 'MEMBER_EXPEL_LIST_ITEM_FORCED',
        name: 'forced',
        align: 'center',
        minWidth: 100,
        formatter: (cell: any) => {
          return cell.value ? 'Y' : 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_EXPEL_LIST_ITEM_WITHDRAW_DATE',
        name: 'withdrawalDateTime',
        align: 'center',
        minWidth: 150,
        formatter: (cell: any) => {
          return cell.value && changeDateFormat(cell.value, 'YYYY-MM-DD');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'MEMBER_EXPEL_LIST_ITEM_REJOINABILITY',
        name: 'rejoinability',
        align: 'center',
        minWidth: 100,
        formatter: (cell: any) => {
          return cell.value ? window.$t('MEMBER_EXPEL_REJOINABILITY_YES') : window.$t('MEMBER_EXPEL_REJOINABILITY_NO');
        },
        copyOptions: {
          useFormattedValue: true
        }
      }
    ],
    header: {
      height: 33
    },
    options: {
      rowHeaders: ['checkbox', 'rowNum'],
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      minRowHeight: 31,
      rowHeight: 31,
      bodyHeight: 190,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0,
        visiblePages: 5
      }
    }
  };

  // 탈퇴 철회
  private async restoreExpelled() {
    if (this.checkAll('restoreExpelled')) {
      let checkedRows = (this.$refs.itemTable as any).gridFunction('getCheckedRows');
      let request = {
        data: {
          mallNo: this.mallNo,
          memberNumbers: checkedRows.map((item: any) => item.memberNo)
        }
      };
      const {data} = await this.$api.putWithdrawalMembersRestore(request);
      let alertMsg = data.successCount > 0 ? (this.$t('MEMBER_EXPEL_RESTORE_SUCCESS_MSG', [data.successCount]) as string) : '';
      if (data.failCount > 0) {
        alertMsg += this.$t('MEMBER_EXPEL_FAIL_MSG', [data.failCount, data.failReasons]);
      }
      alert(alertMsg);
      await this.search(1);
    }
  }

  // 재가입 불가
  // 재가입 불가해제
  private async setRejoin(type: boolean) {
    if (this.checkAll(type ? 'rejoinEnable' : 'rejoinDisable')) {
      let checkedRows = (this.$refs.itemTable as any).gridFunction('getCheckedRows');
      let request = {
        data: {
          mallNo: this.mallNo,
          memberNumbers: checkedRows.map((item: any) => item.memberNo),
          rejoinability: type
        }
      };
      const {data} = await this.$api.putWithdrawalMembersRejoinability(request);
      let alertMsg = '';
      if (data.successCount > 0) {
        if (type) {
          alertMsg = this.$t('MEMBER_EXPEL_REJOIN_ENABLE_SUCCESS_MSG', [data.successCount]) as string;
        } else {
          alertMsg = this.$t('MEMBER_EXPEL_REJOIN_DISABLE_SUCCESS_MSG', [data.successCount]) as string;
        }
      }
      if (data.failCount > 0) {
        alertMsg += this.$t('MEMBER_EXPEL_FAIL_MSG', [data.failCount, data.failReasons]);
      }
      alert(alertMsg);
      await this.search(1);
    }
  }

  private checkAll(type: string) {
    let checkedRows = (this.$refs.itemTable as any).gridFunction('getCheckedRows');
    if (checkedRows.length === 0) {
      alert(this.$t('MEMBER_EXPEL_NOT_SELECTED'));
      return false;
    }
    let memberNumbers = new Set();
    let openIdMemberNumbers = new Set();
    checkedRows.forEach((item: any) => {
      memberNumbers.add(item.memberNo);
      if (item.memberType !== 'MALL') {
        openIdMemberNumbers.add(item.memberNo);
      }
    });
    if (memberNumbers.size === openIdMemberNumbers.size) {
      switch (type) {
        case 'restoreExpelled':
          alert(this.$t('MEMBER_EXPEL_ALERT_RESTORE_RESTORE_EXPELLED'));
          break;
        case 'rejoinDisable':
          alert(this.$t('MEMBER_EXPEL_ALERT_RESTORE_REJOIN_DISABLE'));
          break;
        case 'rejoinEnable':
          alert(this.$t('MEMBER_EXPEL_ALERT_RESTORE_REJOIN_ENABLE'));
          break;
      }
      return false;
    }

    let confirmMsg = '';
    switch (type) {
      case 'restoreExpelled':
        confirmMsg = this.$t('MEMBER_EXPEL_CONFIRM_RESTORE_EXPELLED') as string;
        break;
      case 'rejoinDisable':
        confirmMsg = this.$t('MEMBER_EXPEL_CONFIRM_REJOIN_DISABLE') as string;
        break;
      case 'rejoinEnable':
        confirmMsg = this.$t('MEMBER_EXPEL_CONFIRM_REJOIN_ENABLE') as string;
        break;
    }
    return confirm(confirmMsg);
  }

  private async mounted() {
    await this.fetchMalls();
    this.mallNo = this.malls[0].mallNo;
    await this.search(1);
    let {data} = await this.$api.getWithdrawalMembersRejoinability({params: {mallNo: this.mallNo}});
    this.defaultRejoinBtnFlg = data.rejoinability;
    this.showRejoinBtn = data.rejoinability;
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
}
